import React, { useCallback } from 'react';
// import { Skeleton } from 'antd-mobile-v5';
import { reportClick } from '@/utils/report';
import { openPageNative } from '@/utils/bridge';
import { LINK_PREFIX_MAP } from '../const';
import styles from '../index.less';

const AdInfo = ({ pageName, adsInfo = {}, loading }) => {
  const handleIncomeAdsClick = useCallback(() => {
    const { id, linkURL, linkType } = adsInfo;
    openPageNative({
      url: `${LINK_PREFIX_MAP[linkType]}${encodeURIComponent(linkURL)}`,
    });
    reportClick({
      page_name: pageName,
      button_name: 'income_ads',
      ads_id: id,
    });
  }, [adsInfo, pageName]);

  return (
    <div className={styles.AdInfo}>
      {adsInfo?.id > 0 && (
        <div className={styles.AdInfoCon} onClick={handleIncomeAdsClick}>
          <p className={styles.incomeAds} style={{ color: adsInfo.fontColor }}>
            {adsInfo.title}
          </p>
          <img alt="箭头" src={require('@/assets/images/income/icon_arrow.png')} />
        </div>
      )}
      {/* {loading && <Skeleton animated className={styles.AdSkeleton} />} */}
    </div>
  );
};
export default AdInfo;
